import * as React from "react"
import Layout from "../../components/Layout"
import ContentFullWidthSubLayout from "../../components/ContentFullWidthSubLayout"
import { Helmet } from "react-helmet"
import Seo from "../../components/Seo"
import { Link } from "gatsby"

const IndexPage = () => {
    return (
        <Layout>
            <Seo title="Press Release: OpenVC™ Announces First Close of the OPEN Unicorn® Index Fund" />
            <div className=" py-16">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="text-lg max-w-prose mx-auto">
          <h1>
            <span className="block text-base text-center text-primary font-semibold tracking-wide uppercase">
              Press Release
            </span>
            <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                OpenVC™ Announces First Close of the OPEN Unicorn® Index Fund
            </span>
            <span className="mt-8 block text-sm text-center leading-8 tracking-tight text-gray-900">- May 6, 2025 -</span>
          </h1>
          <p className="mt-8 text-xl text-gray-500 leading-8">
          </p>
        </div>
        <div className="mt-6 prose prose-indigo text-gray-500 mx-auto prose-h1:text-3xl prose-h1:pt-4 prose-h2:my-3">
                <div>
                    <p>
                        NEW YORK, NY — May 6, 2025 — OpenVC™, a pioneer in private market indexing, today announced the successful first close of its flagship OPEN Unicorn® Index Fund (“the Fund”). The Fund provides diversified, rules-based access to 20 of the largest VC-backed private companies in the United States.
                    </p>
                    <p>
                        The OPEN Unicorn® Index Fund is designed to grant exposure to a representative vintage of the NYSE® OPEN VC Unicorn® 20 Index (NYOV20L) and offers investors a diversified portfolio of late-stage, pre-IPO companies. The manager will offer investors the potential for co-investment for each company in the fund where available.
                    </p>
                    <p>
                        "We're excited to enable more participation in the innovation driving the private markets, through an institutional-grade product. We've seen strong early interest in our first close from sophisticated family offices who recognize the quality of our approach. By offering diversified, low-cost exposure to some of the world's most valuable private companies, we're introducing a more accessible and investor-friendly way to invest in a market that has historically been difficult and expensive to navigate," said David Shapiro, Co-Founder and Chief Executive Officer of OpenVC™.
                    </p>
                    <p>
                        The first close commitments have been anchored by the family office of a prominent venture capitalist, with participation from a collection of family offices and registered investment advisors (RIAs) seeking institutional-grade exposure to pre-IPO companies.
                    </p>
                    <p>
                        The Fund, which is currently available to invest directly or through the SEI Access Marketplace, intends to complete its final close by the end of 2025 and expects to begin constructing its portfolio immediately following the first close, sourcing shares through OpenVC™'s secondary market network.
                    </p>

                    <p>
                        “At SEI, we're building a premier alternatives ecosystem that draws on our deep private market expertise to simplify the complex and empower investors,” said Kevin Crowe, Senior Vice President and Head of SEI Access. “Working with OpenVC™ further strengthens our alternatives marketplace by unlocking access to some of the most coveted private companies for investors.”
                    </p>

                    <h1>
                        Interested in investing?
                    </h1>
                    <p>
                        For more information about the OPEN Unicorn® Index Fund visit <a href="https://www.openvc.com">www.openvc.com</a> or contact the Investor Relations team at ir@openvc.com.
                    </p>

                    <h1>
                        About OpenVC™
                    </h1>
                    <p>
                    OpenVC™ is revolutionizing index investing in the late-stage venture capital space, offering improved access to the world's leading private Unicorns. Our mission is to democratize venture capital investment with low-cost, institutional-grade products. With a focus on reducing fees and leveraging the power of index investing, we are committed to making this asset class accessible to all investors. For more information, visit <a href="https://www.openvc.com">www.openvc.com</a>.
                    </p>
                    
                </div>
                </div>
      </div>
    </div>
        </Layout>
    )
}

export default IndexPage
